/* 财务-旅游包车 */
<template>
  <div id="financial">
    <finance-summary-card
      summary-url="/api/v1/manage/financeFlowing/summary"
      :params="summaryParams"
    />
    <div style="color:#999;margin-bottom:10px">【套餐费】用户下单时支付的费用； 【退票费】订单退票时平台收取的费用；【超时/里程费】订单完成时产生的超时费、超里程费</div>
    <custom-table ref="customTable" :has-organization="false" :customOptions="customOptions" :columns="columns"  labelWidth="95" excel-type="CharteredFlowing" :summaryList="[
        { name: 'orderFee', beforeUnit: '￥' },
        { name: 'couponFee', beforeUnit: '￥' },
        { name: 'realFee', beforeUnit: '￥' },
        { name: 'driverIncome', beforeUnit: '￥' },
        { name: 'companyIncome', beforeUnit: '￥' },
      ]"
      @search="p => summaryParams = { ...p }">
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{
          row.created | filterTime("YYYY-MM-DD HH:mm")
        }}</template>
        <template v-else-if="item.prop === 'paymentTime'">{{
          row.paymentTime | filterTime
        }}</template>
        <template v-else-if="item.prop === 'startStationName'">
          <div>{{ row.startStationName }}</div>
          <div style="color:#999">{{row.charteredStartAddress}}</div>
        </template>
        <template v-else-if="item.prop === 'endStationName'">
          <div>{{ row.endStationName }}</div>
          <div style="color:#999">{{row.charteredEndAddress}}</div>
        </template>
        <template v-else-if="item.prop === 'charterName'">
          <div>{{ row.charterName }} ({{row.charteredVehicleSeat}}座)</div>
          <div style="color:#999">￥{{row.charteredBaseFee}}</div>
        </template>
        <template v-else-if="item.prop === 'vehicleSeat'">{{ row.vehicleSeat }}座</template>
        <template v-else-if="item.prop === 'startLineTime'">
          {{ row.schedulingTime | filterTime("MM-DD") }}
          {{ row.startLineTime }} - {{ row.endLineTime }}
        </template>
        <template v-else-if="item.prop === 'charteredFeeType'">
          {{ new Map([ [1,'套餐费'],[2,'退票费'],[3,'超时/里程费'] ]).get(row.charteredFeeType) }}
          {{  }}
        </template>
        <template v-else-if="item.prop === 'realFee'">
          <span class="util-money" v-if="row.realFee || row.realFee === 0">¥{{
            row.realFee
          }}</span>
          <span v-if="!row.realFee && row.realFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'orderFee'">
          <span class="util-money" v-if="row.orderFee || row.orderFee === 0">{{
            row.orderFee
          }}</span>
          <span v-if="!row.orderFee && row.orderFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'couponFee'">
          <span class="util-money" v-if="row.couponFee || row.couponFee === 0">{{ row.couponFee }}</span>
          <span v-if="!row.couponFee && row.couponFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'channelAlias'">
          <span>{{ row[item.prop] | filterConst("CHANNELALIAS") }}</span>
        </template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'lineFee'">
          <span class="util-money" v-if="row.lineFee || row.lineFee === 0">{{
            row.lineFee
          }}</span>
          <span v-if="!row.lineFee && row.lineFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'driverIncome'">
          <template v-if="row.driverIncome || row.driverIncome === 0">
            <span class="util-money">¥{{ row.driverIncome }}</span>
            <span v-if="row.commissionRuleType == 1">
              {{
                row.proportion ? "(" + row.proportion + "%提成" + ")" : ""
              }}</span>
            <span v-if="row.commissionRuleType == 2"> (定额提成)</span>
          </template>

          <span v-if="!row.driverIncome && row.driverIncome !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'companyIncome'">
          <span class="util-money" v-if="row.companyIncome || row.companyIncome === 0">¥{{ row.companyIncome }}</span>
          <span v-if="!row.companyIncome && row.companyIncome !== 0">-</span>
          {{
            row.refundProportion
              ? "(" + row.refundProportion + "%退票费率" + ")"
              : ""
          }}
          {{
            row.ticketChangingProportion
              ? "(" + row.ticketChangingProportion + "%改签费率" + ")"
              : ""
          }}
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
  </div>
</template>

<script>
import FinanceSummaryCard from './components/financeSummaryCard.vue'
export default {
  name: "financial",
  components: { FinanceSummaryCard },
  data() {
    return {
      summaryParams: {},
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/financeFlowing/chartered",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "serialNo", name: "流水号", value: "" },
          { type: "input", field: "orderNo", name: "订单号", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          { type: "input", field: "vehicleNo", name: "车辆编号", value: "" },
          {
            type: "select",
            field: "charteredFeeType",
            name: "费用类型",
            value: null,
            option: [
              { value: null, label: "全部" },
              { value: 1, label: "套餐费" },
              { value: 2, label: "退票费" },
              { value: 3, label: "超时/里程费" }
            ],
          },
          { type: "datetime", field: "time", name: "记录时间", value: [new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 30, new Date().setHours(23, 59, 59, 0)] },
        ],
      },
      // 表头
      columns: [
        { prop: "serialNo", label: "流水号", width: 200 },
        { prop: "orderNo", label: "订单号", width: 200 },
        { prop: "charteredFeeType", label: "费用类型" },
        { prop: "licenseNo", label: "车辆号牌", width: 90 },
        { prop: "vehicleNo", label: "车辆编号", width: 90 },
        { prop: "driverName", label: "司机姓名" },
        { prop: "startStationName", label: "出发地", minWidth: 200 },
        { prop: "endStationName", label: "目的地", minWidth: 200 },
        { prop: "charteredName", label: "所选套餐", width: 120 },
        { prop: "charteredDay", label: "包车天数", width: 70 },
        { prop: "realFee", label: "实际支付", width: 80 },
        { prop: "driverIncome", label: "司机收入", width: 130 },
        { prop: "companyIncome", label: "平台收入", width: 130 },
        { prop: "created", label: "记录时间", width: 130 }
      ],
    };
  },
};
</script>

<style scoped>
</style>
